import type { DataTypeSelector } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

type FieldAttributes =
  | 'displayAttendees'
  | 'displayCategories'
  | 'displayContent'
  | 'displayCoverPicture'
  | 'displayDate'
  | 'displayLocation'
  | 'displayOnlineEvent'
  | 'displayTitle';

type FieldsAttributes = {
  [key in FieldAttributes]: boolean;
};

interface QueryAttributes {
  dataType: DataTypeSelector;
  categories?: { label: string; value: string }[];
}

export enum EmailPublicationType {
  EVENTS = 'events',
  NEWS = 'news',
  EMPTY = 'empty',
}

export interface EmailPublicationDynamicAttributes {
  _selectedItem: {
    value: string | null;
    label: string | null;
  };
  fields: FieldsAttributes;
  fontFamily: string;
  itemId?: number | null;
  singleLine: boolean;
  type: EmailPublicationType;
  query: QueryAttributes;
}

export interface EmailPublicationItemAttributes extends SectionItemAttributes {
  dynamicAttributes: EmailPublicationDynamicAttributes;
}
